(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mega-menu"] && !Shopify.designMode) return;
  try {
    function initHomaMenuPhotos(){
  document.querySelectorAll('.header .mega-menu').forEach(menu=>{
    if(menu.dataset.photosReady)return;
    menu.dataset.photosReady='true';
    const promo=menu.querySelector('.mega-menu__promo');
    if(!promo)return;
    const image=promo.querySelector('img'),destination=promo.querySelector('a');
    if(!image)return;
    const show=event=>{
      const link=event.target.closest('a[data-menu-photo]');
      if(!link||!menu.contains(link))return;
      menu.dataset.photoSelected='true';
      if(image.dataset.currentPhoto===link.dataset.menuPhoto)return;
      image.dataset.currentPhoto=link.dataset.menuPhoto;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src=link.dataset.menuPhoto;
      image.alt=link.dataset.menuPhotoAlt||'';
      if(destination)destination.href=link.href;
    };
    const disclosure=menu.closest('details');
    if(disclosure)disclosure.addEventListener('toggle',()=>{if(!disclosure.open)delete menu.dataset.photoSelected});
    menu.addEventListener('pointerover',show);
    menu.addEventListener('focusin',show);
  });
}
initHomaMenuPhotos();
document.addEventListener('shopify:section:load',initHomaMenuPhotos);
  } catch(e) { console.error(e); }
})();

})();
